import {Component, EventEmitter, Output} from '@angular/core';
import {PollTypeEnum} from "../../shared/enums/poll-type.enum";
import { HeaderComponent } from 'projects/lib-ui/src/shared/components/header/header.component';

@Component({
  selector: 'app-poll-web-intro',
  standalone: true,
  templateUrl: './poll-web-intro.component.html',
  imports: [
    HeaderComponent
  ],
  styleUrls: ['./poll-web-intro.component.scss']
})
export class PollWebIntroComponent {
  @Output() typeSelected = new EventEmitter<PollTypeEnum>();

  protected readonly PollTypeEnum = PollTypeEnum;

  selectType(type: PollTypeEnum) {
    this.typeSelected.emit(type);
  }

}
